import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Select from "../components/form/Select";
import Button from "../components/form/Button";
import { Link } from 'react-router-dom';
import toastr from "toastr";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { authLogin } from "../store/authSlice";
import { emailDomain } from "../helpers";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import Image from "../components/elements/Image";
import { MAIN_LOGO } from "../constant/Constant";

const Signup = () => {
    setTitle("Succession Planning Software for your Business with Succession Now | Signup");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //const [industries,setIndustries] = useState([]);

    const [name,setName] = useState('');
    const [company_name,setCompanyName] = useState('');
    //const [industry,setIndustry] = useState('');
    const [plans,setPlans] = useState([]);
    const [number_of_employees,setNumberOfEmployees] = useState('');
    const [email, setEmail] = useState("");
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    //const [promoCode,setPromoCode] = useState('');
    const [otp,setOtp] = useState('');
    const [isCheck,setIsCheck] = useState(1);
    const [isSignup,setIsSignup] = useState(false);
    const [isVerify,setIsVerify] = useState(false);
    const [isResendOtp,setIsResendOtp] = useState(false);
    const [countDown,setCountDown] = useState('(00:00)');
    const [isDisabled,setIsDisabled] = useState(false);
    const [domain,setDomain] = useState('');

    useEffect(() => {
      // async function industryData() {
      //   try {
      //     const result = await postData("industry/list", {});
      //     if (result.data) {
      //       setIndustries(result.data);
      //     } else {
      //       console.log('industry list message',result.message)
      //     }
      //   } catch (error) {
      //     console.log('Error industry list catch',error.message)
      //   }
      // }
      // industryData();      
      // Plan list
      const loadPlans = async () => {
        try {
          const result = await postData("plans/list", {
            sortQuery : {ordering:1}
          });
          if (result.data) {
            setPlans(result.data)
          }
        } catch (err) {
          console.log(err.message);
        }
      };
      loadPlans();  
    }, []);
    useEffect(() => {
      setDomain(emailDomain(email))
    },[email])

    const onSubmit = async (e) => {
      e.preventDefault();
      setIsSignup(true);
      try {
        const userData = await postData("signup", {
          name : name,
          company_name : company_name,
          //industry: industry,
          number_of_employees:number_of_employees,
          email: email,
          password: password,
          confirm_password : confirmPassword,
          //promo_code : promoCode,
          domain : domain
        });
        if (userData.status && userData.status === 200) {
          setIsSignup(false);
          setIsCheck(2);
          otpCounter();
          toastr.success(userData.message);
        } else {
          toastr.error(userData.message);
          setIsSignup(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsSignup(false);
      }
    };
    
    const onVerify = async (e) => {
      e.preventDefault();
      setIsVerify(true);
      try {
        const userData = await postData("account-verification", {
          email: email,
          otp : otp,
        });
        if (userData.status && userData.status === 200) {
          setIsVerify(false);
          dispatch(authLogin(userData.data));
          localStorage.setItem("accessToken", userData?.accessToken);
          localStorage.setItem("role", userData?.data?.code);
          toastr.success(userData.message);
          return navigate("/dashboard");
        } else {
          toastr.error(userData.message);
          setIsVerify(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsVerify(false);
      }
    };

    const onResendOtp = async (e) => {
      e.preventDefault();
      setIsResendOtp(true);
      try {
        const userData = await postData("resend-otp", {
          email: email,
        });
        if (userData.status && userData.status === 200) {
          setIsResendOtp(false);
          otpCounter();
          toastr.success(userData.message);
        } else {
          toastr.error(userData.message);
          setIsResendOtp(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsResendOtp(false);
      }
    };

    const otpCounter = () => {
      setIsDisabled(true);
      const count_time5 = add_minutes(new Date(), 0.5).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
      const count_time20 = new Date(count_time5).getTime();
      const x20 = setInterval(function() {
        const timezone20 = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
        const now20 = new Date(timezone20).getTime();
        const distance20 = count_time20 - now20;
        // const days20 = Math.floor(distance20 / (1000 * 60 * 60 * 24));
        // const hours20 = Math.floor((distance20 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes20 = Math.floor((distance20 % (1000 * 60 * 60)) / (1000 * 60));
        const seconds20 = Math.floor((distance20 % (1000 * 60)) / 1000);
        // Output the result in an element with id="demo"
        setCountDown('('+ ('0'+minutes20).slice(-2) + ":" + ('0'+seconds20).slice(-2) +')');
        //console.log('('+ ('0'+minutes20).slice(-2) + ":" + ('0'+seconds20).slice(-2) +')');
        // If the count down is over, write some text 
        if (distance20 < 0) {
            clearInterval(x20);
            setCountDown('(00:00)');
            setIsDisabled(false);
        }
      }, 1000);
    } 
    
    const add_minutes = (dt2, minutes2) => {
      return new Date(dt2.getTime() + minutes2*60000);
    }

    return (
        <>
          <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
            <div className="w-full max-w-sm">
            <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
              {/* <div className="w-full mb-5 text-center space-y-2">
                <div className="text-slate-500 text-xl font-extralight leading-none">President/Chief Executive Officer Succession Plan</div>
                <div className="text-sm text-slate-900 font-bold">Yankee Federal Company</div>
              </div> */}
              <div className="w-full bg-white rounded shadow-md py-8 px-6">
                {
                  (isCheck && isCheck === 1)?
                  <div className="divide-y divide-slate-200 space-y-4">
                      <div className="relative">
                          <h1 className="text-xl font-semibold text-center text-slate-700">
                          {t('get_started')}
                          </h1>
                          <div className="text-sm text-slate-400 text-center font-light">
                          {t('please_fill_out_the_information_below_to_start_your_succession_plan')}
                          </div>
                      </div>
                      <div className="pt-4 space-y-4">
                          <div className="relative">
                            <Input
                                label={t('company_name')}
                                labelClasses={"!text-xs"}
                                inputType={"input"}
                                inputPlaceholder={t('company_name')}
                                inputValue={company_name}
                                setInput={setCompanyName}
                            />
                          </div>
                          <div className="relative">
                            <Input
                                label={t('your_full_name')}
                                labelClasses={"!text-xs"}
                                inputType={"input"}
                                inputPlaceholder={t('enter_full_name')}
                                inputValue={name}
                                setInput={setName}
                            />
                          </div>
                          {/* <div className="relative">
                          <Select 
                            xPlacement={'left'} 
                            dropdownClass={'!w-full'} 
                            label={'Industry'}
                            selectedValue={industry} 
                            dropdownData={[
                              { _id: '', label: 'Select', value: '' }, 
                              ...industries.map((item) => (
                                { _id: item?._id, label: item?.name, value: item?._id }
                              ))
                            ]}
                            getSelectedValue={(e) => setIndustry(e._id)}
                            />
                          </div> */}
                          <div className="relative">
                          <Select 
                            label={t('number_of_employees')}
                            labelClasses={'!text-xs'}
                            xPlacement={'left'} 
                            selectedValue={number_of_employees} 
                            dropdownClass={'!w-60'} 
                            dropdownData={
                                [
                                    { _id: ' ', label: t('select_number_of_employees'),value:''} ,
                                    ...plans.map((item) => ({
                                      _id: item?._id, 
                                      label: item?.name,
                                      value:item?.price
                                    }))
                                ]
                            }
                            getSelectedValue={(e) => {setNumberOfEmployees(e._id)}}
                          />
                          {/* <Input
                              label={"Number of employees"}
                              labelClasses={"!text-xs"}
                              inputType={"input"}
                              inputPlaceholder={"Number of employees"}
                              inputValue={number_of_employees}
                              setInput={setNumberOfEmployees}
                          /> */}
                          </div>
                          <div className="relative">
                            <Input
                              label={t('work_email')}
                              labelClasses={"!text-xs"}
                              inputType={"email"}
                              inputPlaceholder={t('work_email_address')}
                              inputValue={email}
                              setInput={setEmail}
                            />
                          </div>
                          <div className="relative">
                          <Input
                              label={t('password')}
                              labelClasses={"!text-xs"}
                              inputType={"password"}
                              inputPlaceholder={t('your_password')}
                              inputValue={password}
                              setInput={setPassword}
                          />
                          </div>  
                          <div className="relative">
                          <Input
                              label={t('confirm_password')}
                              labelClasses={"!text-xs"}
                              inputType={"password"}
                              inputPlaceholder={t('confirm_your_password')}
                              inputValue={confirmPassword}
                              setInput={setConfirmPassword}
                          />
                          </div> 
                          {/* <div className="relative">
                          <Input
                              label={"Promo Code"}
                              labelClasses={"!text-xs"}
                              inputType={"text"}
                              inputPlaceholder={"Enter Promo Code if Available"}
                              inputValue={promoCode}
                              setInput={setPrromoCode}
                          />
                          </div>*/}
                          <div className="relative flex justify-center">
                          <Button
                              buttonClasses=""
                              buttonLabelClasses=""
                              buttonType={"button"}
                              buttonIcon={(isSignup)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
                              buttonIconPosition={"left"}
                              buttonLabel={t('start')}
                              functions={onSubmit}
                              buttonHasLink={false}
                              buttonDisabled={isSignup}
                          />
                          </div>
                      </div>
                      <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                          {t('already_have_an_account')}
                          <Link to={"/signin"} className="text-teal-500 font-semibold">{t('login')}</Link>
                      </div>
                  </div>:
                  <div className="divide-y divide-slate-200 space-y-4">
                    <div className="relative">
                      {/* <h1 className="text-xl font-semibold text-center text-slate-700">Verification code</h1> */}
                      <div className="text-sm text-slate-400 text-center font-light">
                        {t('please_check_your_email_to_verify_your_account')}
                      </div>
                    </div>
                    <div className="pt-4 space-y-4">
                      <div className="relative">
                        <Input
                            label={t('verification_code')}
                            labelClasses={"!text-xs"}
                            inputType={"number"}
                            inputPlaceholder={t('enter_verification_code')}
                            inputValue={otp}
                            setInput={setOtp}
                            errorType={"info"}
                            errorText={countDown}
                        />
                      </div>
                      <div className="relative flex justify-center gap-4">
                        <Button
                            buttonClasses=""
                            buttonLabelClasses=""
                            buttonType={"button"}
                            buttonIcon={(isVerify)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
                            buttonIconPosition={"left"}
                            buttonLabel={t('submit')}
                            functions={onVerify}
                            buttonHasLink={false}
                            buttonDisabled={isVerify}
                        />
                        <Button
                            buttonLabelClasses=""
                            buttonClasses={(isDisabled)?'!bg-slate-200 !text-slate-600 border border-slate-300 pointer-events-none':''} 
                            buttonType={"button"}
                            buttonIcon={(isResendOtp)?"fa-light fa-spinner fa-spin":"fa-light fa-clock"}
                            buttonIconPosition={"left"}
                            buttonLabel={t('resend_otp')}
                            functions={onResendOtp}
                            buttonHasLink={false}
                            buttonDisabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </>
      );
}

export default Signup;